<div
  class="flex w-[284px] flex-col items-start gap-4 rounded-[28px] border-2 border-background-white bg-background-modal p-3 shadow-modal backdrop-blur-2xl"
>
  <lib-select-provider
    [defaultValue]="provider()"
    (itemSelected)="onProviderChange($event)"
    [transparentBackground]="false"
    [label]="'perio_exam_settings_modal_provider' | translate"
    [showAvatar]="true"
    [backgroundColor]="'light-blue'"
    [size]="'large'"
    [alternativeDesign]="true"
    [listPosition]="{
      originX: 'start',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: -16
    }"
    [selectedIcon]="'px-24-arrow-right-1'"
    [customDropdownIcon]="'px-24-arrow-right-1'"
  />
  <div class="h-[1px] w-full bg-background-grey"></div>
  <button class="flex justify-center gap-2" (click)="onPreferencesButtonClick()">
    <svg-icon key="px-24-filter" size="md"></svg-icon>
    {{ 'perio_exam_header_more_modal_preferences' | translate }}
  </button>
  <button class="flex justify-center gap-2" (click)="onResetButtonClick()">
    <svg-icon key="px-24-revert" size="md"></svg-icon>
    {{ 'perio_exam_header_more_modal_reset' | translate }}
  </button>
  @if (isGlobalAdmin()) {
    <button class="flex justify-center gap-2" (click)="onRecordingsButtonClick()">
      <svg-icon key="px-24-play" size="md"></svg-icon>
      Recordings
    </button>
  }
</div>
